module.exports = __webpack_public_path__ + "media/overlays/04-0284d042.png";